import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { call } from '@redux-saga/core/effects';
import ddt from '@wix/da-ddt';
import { convertToServerXhrPayload } from '../../DaEditorWrapper/utils';
import { requestNapi } from '@wix/da-http-client/pkg/request';
export function makePostsPayload(commentData) {
    const { editorContent, rawContentState, featuresData, typeId, itemId, editComment, replyComment, messageId, folderId, shouldDeleteMessage } = commentData;
    return _object_spread({
        typeid: typeId,
        itemid: itemId,
        commentid: editComment ? editComment.commentId : undefined,
        parentid: replyComment ? replyComment.commentId : undefined,
        mcid: messageId,
        folderid: folderId,
        should_delete: shouldDeleteMessage
    }, convertToServerXhrPayload(rawContentState, editorContent, featuresData));
}
export function* sendPublishRequest(commentData) {
    const postData = makePostsPayload(commentData);
    ddt.log('comments', 'posting a comment', postData);
    return yield call(requestNapi, {
        method: 'post',
        url: `/comments/post`,
        data: postData
    }, fakePostResponse);
}
function fakePostResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (typeof window !== 'undefined' && window.doError) {
            return {
                error: 'invalid_request',
                errorDescription: 'Not logged in.',
                status: 'error'
            };
        }
        // eslint-disable-next-line
        const { comments } = require('@wix/da-sample-data');
        const comment = comments[0];
        if (options.url === '/comments/post') {
            comment.posted = Date.now();
            comment.likes = 0;
            comment.isAuthor = true;
            const body = {
                excerpt: '',
                html: {
                    type: 'draft',
                    markup: options.data.editorRaw,
                    features: ''
                }
            };
            comment.textContent = body;
        }
        if (options.data.parentid) {
            comment.parentId = options.data.parentid;
        }
        if (options.data.commentid) {
            comment.commentId = options.data.commentid;
        }
        return comment;
    }
}

//# sourceMappingURL=utils.js.map